<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import user01 from './User 01c.png';
import user02 from './User 02a.png';
import user05 from './User 05c.png';

const { t } = useI18n();

const currentUserIndex = ref(0);
const isVisible = ref(false);

const users = computed(() => [
  {
    image: user01,
    sentence: t('REGISTER.ONBOARDING_MOTION.USER_SENTENCES.SENTENCE_1'),
  },
  {
    image: user02,
    sentence: t('REGISTER.ONBOARDING_MOTION.USER_SENTENCES.SENTENCE_2'),
  },
  {
    image: user05,
    sentence: t('REGISTER.ONBOARDING_MOTION.USER_SENTENCES.SENTENCE_3'),
  },
]);

const currentUser = computed(
  () => users.value[currentUserIndex.value] || users.value[0]
);

let animationInterval = null;

const startAnimation = () => {
  const cycleUser = () => {
    isVisible.value = false;
    setTimeout(() => {
      currentUserIndex.value =
        (currentUserIndex.value + 1) % users.value.length;
      isVisible.value = true;
    }, 500);
  };

  isVisible.value = true;
  animationInterval = setInterval(cycleUser, 3000);
};

onMounted(() => {
  startAnimation();
});

onUnmounted(() => {
  if (animationInterval) {
    clearInterval(animationInterval);
  }
});
</script>

<template>
  <div
    class="flex flex-col justify-center items-center bg-dot-pattern bg-dots-24 h-full w-full bg-neutral-50 dark:!bg-slate-900 dark:bg-dot-pattern-dark rounded-tl-[40px] rounded-bl-[40px]"
  >
    <div class="flex flex-col items-center justify-center w-full gap-6 px-8">
      <div class="flex text-[16px] text-[#1A1A1C] dark:text-white font-bold">
        {{ t('REGISTER.ONBOARDING_MOTION.TITLE') }}
      </div>
      <div
        class="flex flex-col items-center gap-2 transition-opacity duration-500 ease-in-out min-[1440px]:items-center"
        :class="[
          isVisible ? 'opacity-100' : 'opacity-0',
          currentUserIndex % 2 === 0
            ? 'min-[1440px]:flex-row'
            : 'min-[1440px]:flex-row-reverse',
        ]"
      >
        <div
          class="flex max-w-[500px] min-w-[320px] h-[56px] p-0.5 rounded-xl bg-[linear-gradient(150.07deg,#0800EF,#9F13E0,#369EFF)] order-1 min-[1440px]:order-none"
        >
          <div
            class="flex-1 w-full rounded-[10px] bg-white dark:bg-slate-800 py-3 px-4"
          >
            <div
              class="flex items-center h-full w-full text-[#1A1A1C] dark:text-white text-[14px] font-medium text-start"
            >
              {{ currentUser.sentence }}
            </div>
          </div>
        </div>
        <div class="flex-shrink-0 order-2 min-[1440px]:order-none">
          <img
            :src="currentUser.image"
            class="w-12 h-12 rounded-full object-cover"
            alt="User"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
// Animation styles handled by Tailwind classes
</style>
